export const map = {
  CASH_EQUITY: "4729373c-ed4d-439e-a041-6744d81842c0",
  BROKER_COMPANY: "04c0500f-a8c3-11e9-8b5f-00ff12c3b408",
  MSA: "04c05016-a8c3-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE_FIXED: "04c0501f-a8c3-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE_FLOATING_ALL: "04c05025-a8c3-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE_HEDGED: "04c0502c-a8c3-11e9-8b5f-00ff12c3b408",
  CURRENT_BALANCE_FLOATING_UNHEDGED: "04c05032-a8c3-11e9-8b5f-00ff12c3b408",
  EXPENSE_RATIO: "04c05037-a8c3-11e9-8b5f-00ff12c3b408",
  APPRAISED_VALUE: "7d8f2c87-3f5e-11e9-bf92-0242ac140002",
  HEDGE_MTM: "7d8f2d03-3f5e-11e9-bf92-0242ac140002",
  HEDGE_MATURITY: "7d8f2d6c-3f5e-11e9-bf92-0242ac140002",
  HEDGE_TYPE: "7d8f2de9-3f5e-11e9-bf92-0242ac140002",
  BORROWING_ENTITY: "7d8f2e6a-3f5e-11e9-bf92-0242ac140002",
  LENDER: "7d8f2f2f-3f5e-11e9-bf92-0242ac140002",
  EXTENDED_MATURITY_DATE: "7d8f2fac-3f5e-11e9-bf92-0242ac140002",
  MATURITY_DATE: "7d8f3029-3f5e-11e9-bf92-0242ac140002",
  PURCHASE_PRICE: "7d8f310f-3f5e-11e9-bf92-0242ac140002",
  CLOSING_DATE: "7d8f317b-3f5e-11e9-bf92-0242ac140002",
  PROJECT_TYPE: "7d8f31e8-3f5e-11e9-bf92-0242ac140002",
  CAP_RATE: "7d8f326b-3f5e-11e9-bf92-0242ac140002",
  PROJECTED_EXIT_DATE: "7d8f32f0-3f5e-11e9-bf92-0242ac140002",
  DEBT_MF_UNIT: "7d8f33b7-3f5e-11e9-bf92-0242ac140002",
  DEBT_RSF: "7d8f343b-3f5e-11e9-bf92-0242ac140002",
  COVENANT_TEST_FREQUENCY: "7d8f34aa-3f5e-11e9-bf92-0242ac140002",
  PREPAYMENT: "7d8f3581-3f5e-11e9-bf92-0242ac140002",
  LTV: "7d8f35f7-3f5e-11e9-bf92-0242ac140002",
  DEBT_YIELD: "7d8f367e-3f5e-11e9-bf92-0242ac140002",
  DSCR: "7d8f3709-3f5e-11e9-bf92-0242ac140002",
  DSCR_ACTUAL: "f4db2782-c826-11e9-a4f9-00ff12c3b408",
  MAX_RECOURSE: "7d8f37db-3f5e-11e9-bf92-0242ac140002",
  IO_REMAINING: "7d8f3852-3f5e-11e9-bf92-0242ac140002",
  MONTHS_UNTIL_MATURITY: "7d8f38db-3f5e-11e9-bf92-0242ac140002",
  UPCOMING_PAYMENT: "7d8f3952-3f5e-11e9-bf92-0242ac140002",
  PROJECTED_RATE: "7d8f3a45-3f5e-11e9-bf92-0242ac140002",
  CURRENT_RATE: "7d8f3ad6-3f5e-11e9-bf92-0242ac140002",
  UNFUNDED_COMMITMENT: "7d8f3b51-3f5e-11e9-bf92-0242ac140002",
  CURRENT_BALANCE: "7d8f3bce-3f5e-11e9-bf92-0242ac140002",
  EQUITY: "c69ee876-aa37-11e9-8b5f-00ff12c3b408",
  REFI_PROCEEDS: "8d06bc88-8ec8-11ea-9df5-2c4d543da462",
  SUPPLEMENTAL_LOAN_PROCEEDS: "c750e0ad-68a8-4b54-a9ec-2be5b1f4daca",
  REFI_CASH_OUT: "cd6f0738-3f10-4a5e-abe8-5850e2e8b268",
  ALL_IN_EFFECTIVE_RATE: "9aad73ff-ecec-4eae-8d5a-ea69ab01c8e4",
  GOOD_NEWS_MONEY_REMAINING_DOLLAR_AMOUNT: "ba3c8fea-e248-11ea-845c-802bf905d5f8",
  GOOD_NEWS_MONEY_REMAINING_PERCENT: "7ca4b0df-e2f3-11ea-845c-802bf905d5f8",
  EXTENSION_QUALIFICATION: "ee41da19-e2f4-11ea-845c-802bf905d5f8"
};
export const list = Object.values(map);
export default {
  map,
  list
};
